import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const customTheme = {
  dark: false,
  colors: {
    background: '#FAFAF8',
    surface: '#FFFFFF',
    primary: '#496175',
    'primary-darken-1': '#344756',
    secondary: '#847B74',
    'secondary-darken-1': '#6A635D',
    accent: '#A29887',
    neutral: '#AAB4B5',
    'neutral-lighten-1': '#C5CBCC',
    'neutral-darken-1': '#8B9495',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  }
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'customTheme',
    themes: {
      customTheme,
    }
  }
}) 